import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { UTLabel } from '@widergy/energy-ui';

import UTList from '../../../../components/UTList';
import { DesktopViewport, TabletMobileViewport } from '../../../../../constants/deviceSizes';
import { BOTTOM_TILES, WHEEL_BUTTONS } from '../../../../../constants/energyAdvisor';
import { appConfig } from '../../../../../config/customization';
import Images from '../../../../../config/assets';
import { message } from '../../../../../utils/stringUtils';

import WheelButtons from './screens/WheelButtons';
import CenteredIcons from './screens/CenteredIcons';
import BottomTiles from './screens/BottomTiles';
import styles from './styles';

class EnergyAdvisor extends Component {
  state = { opacity: 1 };

  componentWillMount() {
    this.handleTransition(this.props.buttons);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ opacity: 0 }, () => this.handleTransition(nextProps.buttons));
  }

  handleTransition = () => {
    if (!this.state.opacity) this.setState({ opacity: 1 });
  };

  render() {
    const { buttons } = this.props;
    return (
      <div>
        <DesktopViewport>
          {appConfig.energyAdvisor.design === WHEEL_BUTTONS ? (
            <WheelButtons buttons={buttons} />
          ) : appConfig.energyAdvisor.design === BOTTOM_TILES ? (
            <BottomTiles buttons={buttons} />
          ) : (
            <CenteredIcons buttons={buttons} />
          )}
        </DesktopViewport>
        <TabletMobileViewport>
          <div style={styles.mobileTopbar}>
            <UTLabel large extrabold>
              {message('Assessor:energyAdvisor')}
            </UTLabel>
            <img src={Images.energyAdvisorMobileAvatar} style={styles.mobileAvatar} alt="avatar" />
          </div>
          <UTList list={buttons} onClick={this.props.onClick} style={styles.list} />
        </TabletMobileViewport>
      </div>
    );
  }
}

EnergyAdvisor.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      imageHovered: PropTypes.string.isRequired
    }).isRequired
  ).isRequired,
  onClick: PropTypes.func
};

export default Radium(EnergyAdvisor);
